import app from '@/app';
import FormController from './form-controller';
import { SelectControl } from './select-control';
import { InputControl } from './input-control';
import { FileInput } from './file-input';
import { CheckboxControl } from './checkbox-control';
import { TextareaControl } from './textarea-control';
import { RadioGroupControl } from './radio-group-control';
import { NativeFormController } from './native-form-controller';
import { DateInput } from './date-input';
import { TimeInput } from './time-input';

export * from './form-control';
export * from './input-control';
export * from './checkbox-control';
export * from './file-input';
export * from './select-control';
export * from './textarea-control';
export * from './radio-group-control';
export * from './form-manager';
export * from './form-control-initializer';
export * from './textarea-control';

app.register('form', FormController);
app.register('select', SelectControl);
app.register('input', InputControl);
app.register('file-input', FileInput);
app.register('date-input', DateInput);
app.register('time-input', TimeInput);
app.register('checkbox', CheckboxControl);
app.register('textarea', TextareaControl);
app.register('radio-group', RadioGroupControl);
app.register('native-form', NativeFormController);
